import { contentRegistry } from './buildContentRegistry';
export const getDocumentByRoute = (route) => contentRegistry.documentsByRoute.get(route);
//# sourceMappingURL=getDocumentByRoute.js.map